import React, { Component } from 'react';
import HorizontalBar from './HorizontalBar';
import Frame from './Frame';
import IFrame from './IFrame';
import loader from '../../src/components/css/dark/img/loader.gif';
const { AbortController } = window;

class Column extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            columnData: [],
            XlabelString: this.props.XlabelString,
            YlabelString: this.props.YlabelString,
            IFrameId: this.props._Index,
            IsDataLoaded: false
        };
        this.abortController = null;
        this.debounceTimer = null;

    }
    componentDidUpdate(prevProp) {
        if (prevProp.data.RequestJson != this.props.data.RequestJson && this.props.data.type == "Column") {
            //console.log("update Column", this.props)
            this.fetchData();
        }
    }
    componentDidMount() {
        if (this.props.data.type == "Column") {
           // console.log("mount Column", this.props)
            this.fetchData();
        }
    }
    componentWillUnmount() {
        if (this.abortController) {
            this.abortController.abort();
        }
    }
    fetchData() {
        // Cancel any previous pending request
        if (this.abortController) {
            this.abortController.abort();
        }
        // Create a new AbortController for this request
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.setState({
            IsDataLoaded: false
        });
        const requestOptions = {
            method: 'GET',
            signal //  attach abort signal here
            //headers: { 'Content-Type': 'application/json', 'Access-Control-Request-Method': 'GET', 'Access-Control-Request-Headers': 'Origin,Content-Type'}
        };
        fetch(this.props.data.url, requestOptions)
            .then(resp => resp.text())
            .then(data => {
                data = data.replace(/\"/g, "");
                var dataArr = data.split("\n");
                var dataObj = [];
                var dataset = new Array();
                var maxValue = 0, lastElementValue = 0;
                for (var i = 0; i < dataArr.length; i++) {
                    var temp = dataArr[i].split(",");
                    dataObj = [];
                    lastElementValue = 0;
                    if (temp[0] != "Color" && temp[0] != "Total" && temp[0] != "Average" && temp[0] != "") {
                        for (var j = 0; j < temp.length; j++) {
                            //debugger;
                            if (i == 1 && j == temp.length - 1) {
                                maxValue = parseFloat(temp[j])
                            }
                            if (j == temp.length - 1) {
                                lastElementValue = temp[j];
                            }
                            dataObj.push({ data: temp[j], MaxValue: maxValue, lastElementValue: lastElementValue });
                        }
                        dataset.push(dataObj)
                    }
                }
                if (!signal.aborted) {
                    this.setState({
                        IsDataLoaded: true
                    });
                }
                //console.log( dataset);
                this.setState({
                    ...this.state,
                    columnData: dataset,
                    IsDataLoaded: true
                });
            }).catch(err => {
                if (err.name === "AbortError") {
                    // Expected cancel, just ignore
                    //console.log("Fetch request aborted");
                    return;
                }
                // Unexpected error
                //console.error("Fetch error:", err);
                this.setState({
                    IsDataLoaded: true,
                    noDataDisplay: 'Error while loading data'
                });
            });
    }

    render() {
        return (
            <div>
                {this.state.IsDataLoaded ? '' : (<div className="loader-section"><div className="theme-loader"></div></div>)}
                <div id={this.state.IFrameId} scrolling="no" key={"graph-frame" + this.state.IFrameId}>
                <div className="myColumnChart">                    
                    {
                        this.state.columnData!=null?
                    //<table cellSpacing="0" style={{ color: '#8ba6c1'}}>
                    //    <tbody>
                    <div>
                            {
                                        this.state.columnData != null ? this.state.columnData[0] ?
                                            <div className="tableheader" key={"TableHeader0"}>
                                                {this.state.columnData[0]["datasets"].map((e2, i2) => {
                                                    return (
                                                        <div key={'xyz' + i2}>{e2.data}</div>
                                                    )
                                                })}
                                            </div> : null : null
                        }
                        <div className="mainList">
                            {
                                this.state.columnData.map((obj, index) => {

                                    if (index != 0) {
                                        return <div className="tablebody" key={"tablebody" + index}>
                                            {obj.map((e2, i2) => {
                                                return (
                                                    <div key={'xyz' + i2}>{e2.data}</div>
                                                )
                                            })}
                                        </div>
                                    }

                                })
                            }
                        </div>
                    </div>
                //    </tbody>
                //</table>
                            :null
            }
                </div>
                </div>
            </div>
        )
    }

}
export default Column;


class TableHeaderRow extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <tr>
                {this.props.showHorizontalBar == true ? <th /> : null}
                {
                    this.props.data.map((item, index) => {
                        //console.log(item)
                        return <th key={"TableHeaderData" + index}>{item.data}</th>
                    })
                }
            </tr>
        )
    }
}

export { TableHeaderRow };

class TableDataRow extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        var horizontalBarValue = 0, maxValue = 0;
        return (
            <tr>
                {this.props.showHorizontalBar == true ? <td>{this.props.srNo}.</td>:null}
                {
                    this.props.data.map((item, index) => {
                        //console.log(item.data, item.data.indexOf("http"))
                        horizontalBarValue = item.lastElementValue
                        maxValue = item.MaxValue
                        return <td key={"TableRowData" + index}> {item.data.indexOf("http") > -1 ? <a className="linkified" href={item.data} target="_blank">{item.data}</a> : item.data}</td> 
                    })
                }
                {this.props.showHorizontalBar == true && horizontalBarValue > 0 ? <HorizontalBar data={horizontalBarValue} maxValue={maxValue} /> : null}
            </tr>
        )
    }
}

export { TableDataRow };